<template>
    <div class="main">
        <section id="brn-bike-single" class="diagonal">
            <div class="container-fluid container-lg">
                <div class="bike-container">
                    <div class="row">
                        <div class="col-lg-9 bike-border-middle">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div>
                                        <h2 class="title-page">{{ type.name }}</h2>
                                    </div>
                                    <div class="product-image" :class="{ unavailable: type.fullImage === null }"
                                         :style="'background-image: url(' + (type.fullImage ? type.fullImage : './assets/images/icons/no-image.png') + ')'">
                                        <!--                <img :src="type.image.image ? type.image.fullImage : '/assets/images/icons/no-image.png'" :alt="type.type_name">-->
                                    </div>
                                </div>
                                <div class="col-lg-8 ">

                                    <div class="row rentals-select">
                                        <div class="col-md-7">
                                            <RentalSelect ref="sidebar" v-on:openModal="$refs.locationsModal.open()"
                                                          v-if="loadCurrentBike"
                                                          :setCount="setCount"
                                                          :setMapMarker="setMapMarker"
                                                          :bike="loadCurrentBike"
                                                          :bikes="type.bikes"
                                                          :typeLocations="type.bike_location"
                                                          :update-price="updatePrice"
                                                          :itemCount="1"/>
                                        </div>
                                        <div class="col-md-5 d-none d-md-block">
                                            <div class="filter">
                                                <GoogleMap v-if="rentLocationObject" class="mt-3" ref="map"
                                                           @ready="setMapMarker"
                                                           style="min-height: 295px"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="filter">
                                        <h5 class="filter-title">
                                            <span>Add another vehicle:</span>
                                        </h5>
                                    </div>

                                    <div class="bike-carousel container-fluid" v-if="bikesCart.length">
                                        <OwlCarousel
                                            class="owl-container"
                                            :responsive="{
                                                0: {
                                                    items: 1
                                                },
                                                600: {
                                                    items: 2
                                                },
                                                768: {
                                                    items: 4
                                                },
                                                1200: {
                                                    items: 5
                                                }
                                            }"
                                            :loop="false"
                                            :nav="true"
                                            :navContainer="'#bikes-slider-nav'"
                                            :navText="[
                                                '<i class=\'bi bi-arrow-left\'></i>',
                                                '<i class=\'bi bi-arrow-right\'></i>'
                                            ]"
                                            :key="counterCarousel"
                                            :dots="false">
                                            <div
                                                v-for="item in bikesCart"
                                                :key="item.id">
                                                <a :href="'/' + pageSlug + '/' + item.slug" class="product-image"
                                                   :class="{ unavailable: item.image.image === null }"
                                                   :style="'background-image: url(' + (item.image && item.image.image ? item.image.fullImage : './assets/images/icons/no-image.png') + ')'">
                                                </a>
                                                <a :href="'/' + pageSlug + '/' + item.slug"
                                                   class="product-title">{{ item.type_name }}</a>

                                                <div class="amount-selector flex-shrink-0">
                                                    <NumberSelector v-model="item.amount" item-title=""/>
                                                </div>
                                            </div>
                                        </OwlCarousel>
                                        <div id="bikes-slider-nav"></div>
                                    </div>
                                </div>

                                <div class="col-md-12 d-block d-md-none">
                                    <div class="filter">
                                        <GoogleMap v-if="rentLocationObject"
                                                   class="mt-3"
                                                   ref="map_mob"
                                                   @ready="setMapMarker"
                                                   style="min-height: 295px"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <CheckoutSummaryRental class="col-lg-3 bike-border-right"
                                               :key="counter"
                                               :bike="type"
                                               :bikesCart="bikesCart"
                                               :showItems="!!(rentLocation && duration)"
                                               :tax="currentLocation ? currentLocation.tax  : 0"
                                               :current-location="currentLocation ? currentLocation : null"
                                               :is-update="isUpdate"
                        >
                            <template v-if="!isEmpty">
                                <button class="btn btn-primary next-step" :class="{ disabled: loadingState || isUpdate }"
                                        @click="addToCart">
                                    <span v-if="isUpdate">Update...</span>
                                    <span v-else>{{ loadingState ? 'Loading...' : 'book now' }}</span>
                                </button>
                            </template>
                        </CheckoutSummaryRental>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import BorderDecoration from "../components/elements/BorderDecoration";
import ChalkDecoration from "../components/elements/ChalkDecoration";
import ApiRequest from "../../utils/api-request";
import SettingsMixin from "../../mixins/SettingsMixin";
import FareHarborMixin from "../../mixins/FareHarborMixin";
import NumberSelector from "../components/elements/NumberSelector.vue";
import RentalSelect from "../components/blocks/RentailSelect.vue";
import CheckoutSummaryRental from "../components/blocks/checkout/CheckoutSummaryRental.vue";
import {mapActions, mapGetters} from "vuex";
import EventItem from "../../models/EventItem";
import BikeItem from "../../models/BikeItem";
import TourSimpleCard from "../components/cards/TourSimpleCard.vue";
import OwlCarousel from "vue-owl-carousel";
import GoogleMap from "../components/elements/GoogleMap.vue";

export default {
    name: "bikeSingle",
    mixins: [SettingsMixin, FareHarborMixin],
    components: {
        GoogleMap,
        TourSimpleCard,
        CheckoutSummaryRental,
        RentalSelect,
        NumberSelector,
        ChalkDecoration,
        BorderDecoration,
        OwlCarousel
    },
    props: {
        rentalData: {
            required: true
        },
        pageSlug: {
            type: String,
            default: 'rental'
        }
    },
    data() {
        return {
            type: {},
            bikesCart: [],
            isEmpty: false,
            loadingState: false,
            counter: 0,
            counterCarousel: 0,
            loading: false,
            currentLocation: null,
            isUpdate: false,
        }
    },
    computed: {
        ...mapGetters('cart', ['bikeIsInCart']),
        ...mapGetters('app', ['bikes', 'timeOptions', 'locations', 'eventLocations', 'dateNumber']),
        ...mapGetters('filter', ['duration', 'keyword', 'rentLocation', 'journeyDate']),

        currentTimeOption: function () {
            return this.loadCurrentBike.time_options_price.find(o => o.price_id === this.duration.id);
        },
        rentLocationObject() {
            let location = this.locations.find(i => i.id === this.rentLocation);
            return location ? location : null;
        },
        tableTimeOptions() {

            if (this.typeRental === 'events') {
                return JSON.parse(this.$eventTableTimeOptions);
            }

            return JSON.parse(this.$mixTableTimeOptions);
        },
        loadCurrentBike() {
            return this.bikes.find(i => i.type_id === this.type.type_id);
        },

        rentLocation: {
            get: function () {
                return this.$store.getters['filter/rentLocation']
            },
            set: function (value) {
                this.$store.commit('filter/SET_RENT_LOCATION', value)
            }
        },
    },
    beforeMount() {
        this.fetchTimeOptions();
    },
    mounted() {
        this.type = new ApiRequest().convertRentalBySlugResponse(this.rentalData);
        this.loadAnotherBikes();
    },
    methods: {
        ...mapActions('cart', ['addBike']),
        ...mapActions('app', ['fetchTimeOptions','fetchBikes']),

        setMapMarker() {
            let location = this.locations.find(i => i.id === this.rentLocation);
            this.currentLocation = location ? location : null;
            if (!location) return;

            this.type.location_id = location.id;
            this.$refs.map?.resetMarkers();
            this.$refs.map_mob?.resetMarkers();
            this.$refs.map?.addMarker({
                position: {
                    lat: parseFloat(location.lat),
                    lng: parseFloat(location.lng),
                }
            });
            this.$refs.map_mob?.addMarker({
                position: {
                    lat: parseFloat(location.lat),
                    lng: parseFloat(location.lng),
                }
            });
            this.$refs.map?.moveCenter(parseFloat(location.lat), parseFloat(location.lng));
            this.$refs.map_mob?.moveCenter(parseFloat(location.lat), parseFloat(location.lng));
        },
        setSinglePrice() {
            if (this.duration) {
                const timetable = this.currentTimeOption;

                this.type.price = timetable.price;
                this.type.final_price = timetable.final_price;
                if (this.type.price !== this.type.final_price) {
                    this.type.discount = true;
                } else {
                    this.type.discount = false;
                }

            }
        },
        setCount(data) {
            this.type.amount = data ?? 0;
            this.setSinglePrice();
            this.counter++;
        },
        updatePrice() {
            this.isUpdate = true;
        },
        getCurrentTimeOption(id) {
            return this.bikesCart.find(i => i.id === id).time_options_price.find(o => o.price_id === this.duration.id);
        },
        loadAnotherBikes() {
            const bikes = this.bikes
                .filter(i => i.type_id !== this.type.type_id)
                .map(i => {
                    if (this.duration) {
                        let timeOption = i.time_options_price.find(o => o.price_id === this.duration.id)
                        let price = timeOption.price;
                        i.price = price ?? 0;
                        if (i.discount > 0) {
                            i.final_price = price - (price * (i.discount / 100)) ?? 0;
                        } else {
                            i.final_price = price ?? 0;
                        }
                    }
                    i.amount = 0;
                    return i;
                })
                .filter(i => i.final_price > 0)

            this.bikesCart.splice(0, this.bikesCart.length, ...bikes);

            this.counter++;
            this.counterCarousel++;
        },
        getCart() {
            return this.bikesCart.filter(i => i.amount > 0);
        },
        wellDoneNotify() {
            this.$notify({
                title: 'Well done!',
                text: '«' + this.type.type_name + '» was added to cart successfully!',
                duration: 2000
            });

            window.location.href = "/checkout"
        },
        oopsNotify() {
            this.$notify({
                title: 'Oops!',
                text: 'Can\'t add this bike, because there is tour in cart!'
            });
        },
        notSelectNotify() {
            this.$notify({
                title: 'Select!',
                text: 'Please select time and location!'
            });
        },
        promoRemoveNotify() {
            this.$notify({
                title: 'Promo-code was removed!',
                text: 'Discounted bikes can\'t be used with promo-codes!'
            });
        },

        addToCart() {
            if (this.loading === true && (!this.rentLocation || !this.duration)) {
                this.notSelectNotify();
                return;
            }
            if (this.type.amount > 0) {
                const amount = this.type.amount;
                const bike = this.loadCurrentBike;

                this.addBike(new BikeItem(bike, amount, this.currentTimeOption)).then(res => {
                    switch (res) {
                        case 0:
                            this.wellDoneNotify();
                            return;
                        case 1:
                            this.oopsNotify();
                            return;
                        case 2:
                            this.promoRemoveNotify();
                            return;
                    }
                });
            }
            this.bikesCart.filter(i => i.amount > 0).forEach(i => {
                this.addBike(new BikeItem(i, i.amount, this.getCurrentTimeOption(i.id))).then(res => {
                    switch (res) {
                        case 0:
                            this.wellDoneNotify();
                            return;
                        case 1:
                            this.oopsNotify();
                            return;
                        case 2:
                            this.promoRemoveNotify();
                            return;
                    }
                });
            });
        },
    },
    watch: {
        dateNumber() {
            if(this.type.amount > 0) {
                this.type.amount = this.type.amount - 1;
                this.setSinglePrice();
                this.counter++;

                setTimeout(() => {
                    this.type.amount = this.type.amount + 1;
                    this.setSinglePrice();
                    this.counter++;
                    this.isUpdate = false;
                }, 300);
            } else {
                this.isUpdate = false;
            }
        },
        duration: {
            handler: async function () {
                this.setSinglePrice();
                this.loadAnotherBikes();
                this.counter++;
            }
        },
        bikes: {
            handler() {
                this.loadAnotherBikes();
            }
        },
        bikesCart: {
            deep: true,
            handler() {
                if (this.loading === true && (!this.rentLocation || !this.duration)) {
                    this.notSelectNotify();
                }
                this.loading = true;

                this.counter++
            }
        },
        rentLocation: {
            deep: true,
            handler() {
                this.setMapMarker()
            }
        }
    }
}
</script>

<style scoped>

</style>
